<template>
  <div class="modal-container">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="tab1">托运人订单</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="search-box">
        <vxe-input
            v-model="filterName"
            type="search"
            placeholder="订单编号"
            @keyup.enter.native="search"
            @search-click="search"
            class="choose-search-input"
        ></vxe-input>
        <vxe-input
            style="margin-left: 10px"
            v-model="contractTitle"
            type="search"
            placeholder="订单标题"
            @keyup.enter.native="search"
            @search-click="search"
            class="choose-search-input"
        ></vxe-input>
      </div>
    </div>
    <!-- <div class="choose-search-box">
      <vxe-input v-model="filterName" type="search" placeholder="搜索"  @keyup.enter.native="search" @search-click="search" class="choose-search-input"></vxe-input>
    </div>-->
    <div class="choose-box clearfix">
      <!-- <vxe-toolbar>
        <template v-slot:buttons>
          <vxe-input v-model="filterName" type="search" placeholder="搜索"  @keyup.enter.native="search" @search-click="search" class="choose-search-box"></vxe-input>
        </template>
      </vxe-toolbar>-->
      <vxe-table
          class="table-style"
          highlight-hover-row
          highlight-current-row
          show-overflow
          :auto-resize="true"
          border="none"
          align="center"
          max-height="450"
          stripe
          :loading="loading"
          :data="orderListData"
          @current-change="currentChangeEvent"
      >
        <vxe-table-column
            field="buyerOrdersNum"
            title="子订单编号"
            width="130"
        ></vxe-table-column>
        <vxe-table-column
            field="contractTitle"
            title="订单标题"
            width="120"
        ></vxe-table-column>
        <vxe-table-column
            field="buyerName"
            title="托运人名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="sellerName"
            title="承运人名称"
            width="200"
        ></vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="货名" width="105">
          <template slot-scope="{ row, $rowIndex }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
              row.goodsRtnVos[0].goodsName
            }}</span>
            <Icon
                type="ios-arrow-down"
                @click.stop="clickEvent3($rowIndex)"
                v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
            />
            <vxe-pulldown :ref="$rowIndex" transfer placement="bottom">
              <template v-slot:dropdown>
                <div class="my-dropdown3">
                  <vxe-table
                      auto-resize
                      style="width: 815px"
                      :data="row.goodsRtnVos"
                      stripe
                      show-overflow
                      align="center"
                      max-height="480"
                      :show-header="false"
                  >
                    <vxe-table-column
                        field="goodsName"
                        title="货名"
                        width="105"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="unit"
                        title="单位"
                        width="60"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="counts"
                        title="数量"
                        width="75"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="price"
                        title="单价"
                        width="75"
                    ></vxe-table-column>
                    <vxe-table-column field="isTax" title="含税" width="60">
                      <template slot-scope="{ row }">
                        <span>{{ row.isTax | taxMap }}</span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="carShipNum"
                        title="车船号"
                        width="120"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="beginPlace"
                        title="起运地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column
                        field="endPlace"
                        title="目的地"
                        width="90"
                    ></vxe-table-column>
                    <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
                      <template slot-scope="{ row }">
                        <span>{{ row.beginTime | timeFormatDate }}</span>
                      </template>
                    </vxe-table-column>
                  </vxe-table>
                </div>
              </template>
            </vxe-pulldown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="单位" width="60">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
              row.goodsRtnVos[0].unit
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="数量" width="75">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
              row.goodsRtnVos[0].counts
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="单价" width="75">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
              row.goodsRtnVos[0].price
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="含税" width="60">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
              row.goodsRtnVos[0].isTax | taxMap
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="车船号" width="120">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
              row.goodsRtnVos[0].carShipNum
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="起运地" width="90">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
              row.goodsRtnVos[0].beginPlace
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="目的地" width="90">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
              row.goodsRtnVos[0].endPlace
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsRtnVos" title="受载/起运时间" width="140">
          <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{
              row.goodsRtnVos[0].beginTime | timeFormatDate
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="associateCounts" title="交接数量" width="100">
          <!-- <template slot-scope="{ row }">
            <span v-if="row.goodsRtnVos && row.goodsRtnVos.length > 0">{{ row.goodsRtnVos[0].associateCounts }}</span>
          </template>-->
        </vxe-table-column>
        <vxe-table-column
            field="receivablesAmount"
            title="应收金额"
            width="120"
        >
          <template slot-scope="{ row }">
            <span>{{ row.receivablesAmount | numberToCurrency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="receivedAmount" title="已收金额" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.receivedAmount | numberToCurrency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="uncollectedAmount"
            title="未收金额"
            width="120"
        >
          <template slot-scope="{ row }">
            <span>{{ row.uncollectedAmount | numberToCurrency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="invoiceAmount" title="发票总额" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.invoiceAmount | numberToCurrency }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="updateUser"
            title="创建人"
            width="100"
        ></vxe-table-column>
        <vxe-table-column field="updateTime" title="创建时间" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.updateTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import $C from "@/consts/index";
  import Auth from "@/utils/auth.js";

  export default {
    name: "ChooseContract",
    data() {
      let userInfoValue = {};
      if (Auth.isLogin()) {
        userInfoValue = Auth.getAuth();
      }
      return {
        userInfoValue,
        loading: false,
        detailVisible: false,
        filterName: "",
        contractTitle: '',
        orderListData: [{}],
        page: {
          currentPage: 1,
          pageSize: 8,
          totalResult: 100,
        },
        type: null,
        selectTab: "tab1",
        paramsObj: null,
      };
    },
    activated() {
      this.init();
    },
    methods: {
      init(type) {
        this.filterName = null;
        this.contractTitle = null;
        this.paramsObj = null;
        this.page = {
          currentPage: 1,
          pageSize: 8,
          totalResult: 100,
        };
        this.type = type;
        this.queryOrderList(type);
      },
      async queryOrderList(type) {
        this.loading = true;
        let path =
          this.userInfoValue.identityType === 0
            ? "queryOrdersBuyerList"
            : "queryOrdersBuyerListWithoutPermission";
        let res = await $api.order.post(path, {
          page: this.page.currentPage,
          rows: this.page.pageSize,
        });
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          this.orderListData = res.data.rows;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
        this.loading = false;
        // $api.order.queryOrdersBuyerListWithoutPermission
        //   .POST({
        //     data: {
        //       page: this.page.currentPage,
        //       rows: this.page.pageSize,
        //     },
        //   })
        //   .then((res) => {
        //     if (res.status === 1) {
        //       this.page.totalResult = res.data.total;
        //       this.orderListData = res.data.rows;
        //     } else {
        //       this.$XModal.alert({
        //         message: res.message ? res.message : "接口异常",
        //         status: "error",
        //       });
        //     }
        //     this.loading = false;
        //   });
      },

      changePage({currentPage, pageSize}) {
        // 分页
        if (!this.paramsObj) {
          this.page.currentPage = currentPage;
          this.page.pageSize = pageSize;
          let changeObj = {
            page: this.page.currentPage,
            rows: this.page.pageSize,
          };
          this.queryOrderListByObj(changeObj);
        } else {
          let obj = {
            page: currentPage,
            rows: pageSize,
          };
          Object.assign(obj, this.paramsObj);
          this.queryOrderListByObj(obj);
        }
      },
      clickEvent3(rowIndex) {
        this.$refs[rowIndex].togglePanel();
      },
      currentChangeEvent({row}) {
        this.$emit("choose", row);
      },
      search() {
        this.loading = true;
        this.page.currentPage = 1;
        let obj = {
          buyerOrdersNum: this.filterName,
          contractTitle: this.contractTitle,
          page: this.page.currentPage,
          rows: this.page.pageSize,
        };
        let paramsObj = {
          buyerOrdersNum: this.filterName,
          contractTitle: this.contractTitle,
        };
        this.paramsObj = paramsObj;
        this.queryOrderListByObj(obj);
      },

      async queryOrderListByObj(obj) {
        this.loading = true;
        let path =
          this.userInfoValue.identityType === 0
            ? "queryOrdersBuyerList"
            : "queryOrdersBuyerListWithoutPermission";
        let res = await $api.order.post(path, obj);

        if (res) {
          this.page.totalResult = res.data.total;
          this.orderListData = res.data.rows;
          this.loading = false;
        }

        // $api.order.queryOrdersBuyerListWithoutPermission
        //   .POST({
        //     data: obj,
        //   })
        //   .then((res) => {
        //     this.page.totalResult = res.data.total;
        //     this.orderListData = res.data.rows;
        //     this.loading = false;
        //   });
      },
      cancel() {
      },
      close() {
        this.$refs.xTable.clearCurrentRow();
      },
    },
  };
</script>

<style scoped>
  .modal-container {
    position: relative;
    height: 100%;
  }

  .btn-down {
    border: none;
  }

  .btn-down:focus {
    outline: none;
    border-color: transparent;
    box-shadow: none;
    background: transparent;
  }

  .btn-down.ivu-btn {
    background: transparent;
  }

  .btn-down.ivu-btn:hover {
    background: transparent;
  }
</style>